module.exports = __webpack_public_path__ + "static/img/player_head_2.accf417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_2.jpg
// module id = sLDl
// module chunks = 1